import { BrandMark } from '@orbitalwatch/design';
import type { ReactNode } from 'react';

/** The faint orbit lines behind the splash and session-expired boards (decorative, `currentColor` = border token). */
function Orbits() {
    return (
        <svg className="ark-fullscreen-orbits" viewBox="0 0 1440 900" preserveAspectRatio="xMidYMid slice" fill="none" aria-hidden="true" focusable="false">
            <g stroke="currentColor" strokeWidth="1">
                <ellipse cx="720" cy="450" rx="760" ry="330" transform="rotate(-18 720 450)" />
                <ellipse cx="720" cy="450" rx="560" ry="230" transform="rotate(-18 720 450)" />
            </g>
            <circle cx="1182" cy="138" r="4" fill="currentColor" />
        </svg>
    );
}

export interface FullScreenFrameProps {
    title: ReactNode;
    /** `status` (splash: announced politely) or `main` content (session expired). */
    role?: 'status' | 'main';
    children?: ReactNode;
}

/** Splash and session-expired frame (boards Shell-Splash / Shell-SessionExpired): no shell, the brand mark centred. */
export function FullScreenFrame(props: FullScreenFrameProps) {
    const Tag = props.role === 'main' ? 'main' : 'div';
    return (
        <Tag className="ark-fullscreen" role={props.role === 'status' ? 'status' : undefined} aria-live={props.role === 'status' ? 'polite' : undefined}>
            <Orbits />
            <BrandMark size={72} />
            <h1>{props.title}</h1>
            {props.children}
        </Tag>
    );
}
